module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-steak-6730c5bb8c2c3f4b15094da1e5ab43cc.png";